import { combineReducers } from 'redux';
import { createReducer as createReducerRtk } from '@reduxjs/toolkit';

import { ListDiscounts200Response } from '@ce-openapi/moka-inventory-discount-service-ts-axios-client';
import {
  setCustomDiscounts,
  setCustomDiscountsCursor,
  setDiscounts,
} from '../../actions/library/discount';
import {
  LIBRARY_DISCOUNT_SET_OUTLETS,
  LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL,
  LIBRARY_DISCOUNT_SET_CURRENT_PAGE,
  LIBRARY_DISCOUNT_SET_TOTAL_PAGE,
  LIBRARY_DISCOUNT_UNSET_DISCOUNT,
  LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT,
  LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT,
  LIBRARY_DISCOUNT_IS_SUBMITTING_FORM,
  LIBRARY_DISCOUNT_SHOW_ASSIGN_OUTLET_MODAL,
  LIBRARY_DISCOUNT_HIDE_ASSIGN_OUTLET_MODAL,
  LIBRARY_DISCOUNT_SET_SELECTED_OUTLETS,
  LIBRARY_DISCOUNT_SET_PARTIAL_OUTLETS,
  LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_OUTLET_NOT_ASSIGNED,
  LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_OUTLET_NOT_ASSIGNED,
  LIBRARY_DISCOUNT_OUTLET_SHOW_BUTTON_VIEW_MORE_OUTLETS,
  LIBRARY_DISCOUNT_OUTLET_HIDE_BUTTON_VIEW_MORE_OUTLETS,
  LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_DUPLICATE_DISCOUNT_NAME,
  LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_DUPLICATE_DISCOUNT_NAME,
} from '../../actions/library/discount/constants';
import { Discount } from '../../api/libraries/discounts';
import createReducer from '../../utils/createReducer';

const currentPage = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_CURRENT_PAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.currentPage,
});

const deletedDiscount = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.deletedDiscount,
});

const discountDetail = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT]: () => null,

  [LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.discount,

  [LIBRARY_DISCOUNT_UNSET_DISCOUNT]: () => null,
});

const discounts = createReducerRtk<
  Discount[] | ListDiscounts200Response['results']
>([], (builder) => {
  builder
    .addCase(setDiscounts, (state, { payload }) => payload)
    .addCase(setCustomDiscounts, (state, { payload }) => {
      return payload;
    });
});

const discountsCursor = createReducerRtk(
  { cursor: null, completed: false },
  (builder) => {
    builder.addCase(
      setCustomDiscountsCursor,
      (state, { payload: { cursor, completed } }) => {
        return {
          cursor,
          completed,
        };
      }
    );
  }
);

const isSubmittingForm = createReducer(false, {
  [LIBRARY_DISCOUNT_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isSubmittingForm,
});

const newDiscount = createReducer(null, {
  [LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT]: () => true,
  [LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL]: () => false,
  [LIBRARY_DISCOUNT_UNSET_DISCOUNT]: () => null,
});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_DISCOUNT_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const showDeleteDiscountModal = createReducer(false, {
  [LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL]: () => true,
  [LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL]: () => false,
});

const showDetail = createReducer(false, {
  [LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT]: () => true,
  [LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL]: () => true,
  [LIBRARY_DISCOUNT_UNSET_DISCOUNT]: () => false,
});

const totalPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_DISCOUNT_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

const showAssignOutletModal = createReducer(false, {
  [LIBRARY_DISCOUNT_SHOW_ASSIGN_OUTLET_MODAL]: () => true,
  [LIBRARY_DISCOUNT_HIDE_ASSIGN_OUTLET_MODAL]: () => false,
});

const selectedOutlets = createReducer([], {
  [LIBRARY_DISCOUNT_SET_SELECTED_OUTLETS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.selectedOutlets,
});

const showErrorOutletNotAssigned = createReducer(false, {
  [LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_OUTLET_NOT_ASSIGNED]: () => true,
  [LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_OUTLET_NOT_ASSIGNED]: () => false,
});

const showViewMoreOutletButton = createReducer(true, {
  [LIBRARY_DISCOUNT_OUTLET_SHOW_BUTTON_VIEW_MORE_OUTLETS]: () => true,
  [LIBRARY_DISCOUNT_OUTLET_HIDE_BUTTON_VIEW_MORE_OUTLETS]: () => false,
});

const showErrorDuplicateDiscountName = createReducer(false, {
  [LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_DUPLICATE_DISCOUNT_NAME]: () => true,
  [LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_DUPLICATE_DISCOUNT_NAME]: () => false,
});

const partialOutlets = createReducer([], {
  [LIBRARY_DISCOUNT_SET_PARTIAL_OUTLETS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.partialOutlets,
});

export default combineReducers({
  currentPage,
  deletedDiscount,
  discountDetail,
  discounts,
  discountsCursor,
  isSubmittingForm,
  newDiscount,
  outlets,
  selectedOutlets,
  showAssignOutletModal,
  showDeleteDiscountModal,
  showDetail,
  totalPage,
  showErrorOutletNotAssigned,
  showViewMoreOutletButton,
  showErrorDuplicateDiscountName,
  partialOutlets,
});
